import { css } from "@emotion/react";
import styled from "@emotion/styled";
import {
  PrimaryButtonProps,
  PrimaryButton as UnlikelyPrimaryButton,
} from "@unlikelyai-magic/ui/buttons";

export const PrimaryButton = styled(UnlikelyPrimaryButton)<PrimaryButtonProps>`
  ${({ theme }) => css`
    color: ${theme.colors.text.dark.default};
    background: ${theme.colors.action.primary.default};

    &:hover,
    &:focus,
    &:active,
    &.ant-btn-loading {
      background: ${theme.colors.action.primary.hover};
    }

    &:disabled,
    &:disabled:hover {
      color: ${theme.colors.text.dark.default};
      background: ${theme.colors.action.primary.inactive};

      cursor: not-allowed;
    }
  `}
`;
